// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#3081ef","menuBgNew":"#2a2d39"};